import type { RootState } from '@/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';

export const useEmailActivity = () => {
	const [scheduledEmailActivity] = useSelector<RootState, [any]>(
		state => [state.email.getIn(['email', 'scheduled', 'activity']).toJS()],
		shallowEqual
	);

	return { scheduledEmailActivity };
};
